<template>
    <b-modal @ok="ok" :title="Core.Definition.getDefinition('Utilisateur')" ok-variant="success" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light" v-model="dataShow">
        <SimpleForm ref="simpleForm" :structure="dataFormStructure"></SimpleForm>
    </b-modal>
</template>

<script>
    import Vue from 'vue'
    import SimpleForm from './SimpleForm'
    Vue.use(require('vue-moment'))
    export default {
        name: 'ModalUser',
        components: {
            SimpleForm
        },
        props: {
            validate: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Object,
                default: function () {
                    return {
                        firstname: '',
                        lastname: '',
                        email: '',
                        birthdate: null,
                        phone: '',
                        mobile: ''
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(id) {
                    this.dataId = id
                },
                get() {
                    return this.dataId
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataUser = this.value
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataUser: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    birthdate: null,
                    phone: '',
                    mobile: ''
                },
                dataAlert: {
                    display: false,
                    message: ''
                },
                dataFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'email'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'birthdate'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'phone'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'firstname',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'email',
                            type: 'email',
                            required: true,
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        },
                        {
                            id: 'birthdate',
                            type: Core.Value.typeDatePicker,
                            required: false,
                            label: Core.Definition.getDefinition('Date de naissance'),
                            value: null,
                            onChange() {}
                        },
                        {
                            id: 'phone',
                            type: 'phone',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        }
                    ]
                }
            }
        },
        methods: {
            ok(e) {
                e.preventDefault()
                if (this.$refs.simpleForm.validate()) {
                    this.dataUser = this.$refs.simpleForm.getValues()
                    this.$emit('ok', this.dataUser)
                    this.open = false
                }
            }
        }
    }
</script>
